import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/do/Layout"
import SEO from "../../components/Seo"
import Faq from "../../components/shared/faq/Faq"
import { PAGE } from "../../constants"

const faq = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.faq} siteTitle="Do" />
      <HeadingL title={PAGE.title.faq} target="do" />
      <Faq target="do" />
    </Layout>
  )
}

export default faq
